module.exports = __webpack_public_path__ + "img/employee.70f9e944.svg";